import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import Modal from '../common/Modal/Modal';
import { theme } from '../../../../themes';

class OopsErrorMessage extends Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    return (
      <div className="oopsErrorMessageContainer">
        <Modal>
          <Grid>
            <div className="oopsErrorMessageContent">
              <div className="title">Oops! Something went wrong, please try again.</div>
              <div className="OkayButtonContainer">
                <button
                  style={{ backgroundColor: theme.colors.primaryAccent, borderColor: theme.colors.primaryAccent }}
                  onClick={this.props.onErrorMessageOkay}
                >
                  Okay
                </button>
              </div>
            </div>
          </Grid>
        </Modal>
      </div>
    );
  };
}

export default OopsErrorMessage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/OopsErrorMessage/OopsErrorMessage.js